export enum Direction {
  ASC = 'asc',
  DESC = 'desc',
}

export type Comparator<T> = (a: T, b: T) => number;
